import React, { Component } from 'react';
//  Components
import Header from '../components/Header/header';

class PoliticasCompra extends Component {
   render() {
      return (
         <div className="flex">
            <div className="column">
               <Header inicio={true}></Header>
               <div className="politicas justify-center">
                  <div className="container">
                     <div className="column">
                        <div className="white-space-48"></div>
                        <h2 className="color-secondary quicksand">
                           POLÍTICAS DE DEVOLUCIÓN
                        </h2>
                        <div className="white-space-24"></div>

                        <p className="text-justify">
                           Nuestra política de devolución es muy sencilla; el
                           cliente podrá devolver cualquier artículo comprado
                           bajo las siguientes condiciones:
                        </p>
                        <div className="white-space-8"></div>
                        <ol>
                           <li>
                              Si el artículo presenta defectos de fabricación,
                              descompostura o ruptura que no hayan sido
                              provocadas por mal uso y/o maltrato del producto.
                           </li>
                           <li>
                              Si existe equivocación en el artículo enviado por
                              parte de la empresa.
                           </li>
                           <li>Si se reporta dentro del plazo estipulado.</li>
                           <li>
                              Para hacer válida la garantía el cliente deberá:
                           </li>
                           <li>
                              Reportarlo durante los primeros 5 días hábiles,
                              posteriores a su confirmación de entrega,
                              presentando su nota de venta o factura a los
                              siguientes teléfonos:998-887-9509 o 998-310-3312{' '}
                           </li>
                        </ol>

                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Es INDISPENSABLE conservar la envoltura original, así
                           mismo el artículo en cuestión NO deberá presentar
                           muestras de maltrato así como todos los componentes y
                           accesorios originales.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Si la compra se realizó por medio de la página web,
                           el cliente deberá enviar un correo integrando
                           fotografías del defecto del producto, número de orden
                           de venta, motivo por el cual se tendría que hacer
                           válida la garantía.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           <strong>
                              {' '}
                              POR HIGIENE NO HAY CAMBIO NI DEVOLUCIÓN
                           </strong>{' '}
                           en los siguientes productos:
                        </p>
                        <div className="white-space-8"></div>
                        <ul>
                           <li>
                              AUXILIARES PARA BAÑO (cómodos, orinales, sillas
                              ducha, aumentos para baño etc.)
                           </li>
                           <li>
                              ORTOPEDIA BLANDA (coderas, rodilleras, tobilleras,
                              muñequeras, fajas, collarines, almohadas, cojines
                              y colchones.)
                           </li>
                           <li>
                              CALCETINES, MEDIAS ELÁSTICAS O DE COMPRESIÓN Y
                              BOTAS.
                           </li>
                           <li>ARTÍCULOS PARA EL PIE</li>
                        </ul>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           GARANTÍA LIMITADA: Todos los productos cuentan con
                           una garantía por defecto de fabricación de 5 días
                           directamente con expomedica (solo aplica para la
                           venta en línea, quedando deslindadas cualquier
                           sucursal u otro punto de venta), después de este
                           plazo la garantía la determina directamente el
                           fabricante o importador, la cual puede encontrar en
                           la póliza de garantía incluida dentro de su producto
                           (según sea el caso).
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Procedimiento para realizar garantía por servicio de
                           mensajería.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Podrás enviar la mercancía, utilizando de
                           preferencia, la misma compañía de mensajería que le
                           entregó la mercancía, asegurando perfectamente el
                           paquete el cual deberá contener la factura original,
                           una nota aclaratoria que indique el motivo de la
                           devolución, y si deseas la reposición del artículo o
                           el reembolso de tu dinero.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Si se envía la mercancía por mensajería, deberás
                           asegurarte de anotar correctamente el siguiente
                           destinatario:
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Ventas en línea Av. Coba Lt 25-1, Mz 13, Sm.22 Local
                           102-103, Cancún Q. Roo.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           LA GARANTÍA QUEDA ANULADA:
                        </p>
                        <div className="white-space-8"></div>
                        <ul>
                           <li>
                              Si fue manipulado por terceros no autorizados.
                           </li>
                           <li>Por uso inadecuado del producto.</li>
                        </ul>
                        <div className="white-space-24"></div>
                        <h2 className="color-secondary quicksand">
                           CANCELACIÓN
                        </h2>
                        <div className="white-space-24"></div>
                        <p className="text-justify">
                           Si el pedido se realizó antes de las 12:00 pm, tiene
                           hasta las 18:00 horas Para cancelarlo.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           No realizamos cargos adicionales por la cancelación
                           de producto, sin embargo es importante que nuestros
                           operadores sean notificados dentro del plazo para
                           brindarle una atención oportuna.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Para notificar su cancelación o realizar una
                           aclaración ponemos a sus órdenes las siguientes
                           formas de contacto:
                        </p>
                        <div className="white-space-8"></div>

                        <ul>
                           <li>Vía telefónica al 998-887-95-09</li>
                           <li>
                              Correo electrónico a la dirección :{' '}
                              <a href="mailto:contacto@expomedica.mx">
                                 {' '}
                                 contacto@expomedica.mx{' '}
                              </a>
                           </li>
                           <li>
                              {' '}
                              Chat <a href="tel:9983509562"> 998-350-95-62 </a>
                           </li>
                        </ul>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Si ya efectuó su pago, su reembolso se realizará de
                           acuerdo a su forma de pago:
                        </p>
                        <div className="white-space-8"></div>
                        <ul>
                           <li>
                              Pago con Tarjeta/Depósito Bancario/Transferencia
                              se programa la devolución a partir de la
                              confirmación de 3 puntos:
                              <ul>
                                 <li>
                                    Aviso de cancelación con un operador y/o vía
                                    correo electrónico.
                                 </li>
                                 <li>
                                    Recepción del producto en las oficinas de
                                    expomedica para su valoración.
                                 </li>
                                 <li>
                                    Confirmación de cuenta bancaria donde se
                                    realizará el depósito correspondiente a la
                                    devolución.
                                 </li>
                              </ul>
                           </li>
                        </ul>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Una vez confirmadas éstas características, su
                           devolución se programará dentro de los próximos 15
                           DÍAS HÁBILES, siendo los días VIERNES la aplicación
                           de pagos.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Openpay el proceso de devolución consiste en la
                           confirmación de 3 puntos:
                        </p>
                        <div className="white-space-8"></div>
                        <ul>
                           <li>
                              Aviso de cancelación con un operador y/o vía
                              correo electrónico.
                           </li>
                           <li>
                              Recepción del producto en las oficinas de
                              expomedica para su valoración.
                           </li>
                           <li>
                              Por último se debe notificar la devolución de su
                              pago directamente en su cuenta de Openpay.
                           </li>
                        </ul>
                        <div className="white-space-24"></div>
                        <h2 className="color-secondary quicksand">
                           POLÍTICAS DE ENVÍOS
                        </h2>
                        <div className="white-space-24"></div>
                        <p className="text-justify">
                           Los envíos se hacen a toda la República Mexicana
                           mediante servicio de paquetería convencional.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           ENTREGA EN DOMICILIO.- Para realizar nuestros envíos
                           utilizamos _________________________para productos
                           que no excedan los 80 kg, en esta modalidad el
                           cliente podrá escoger entre e modos de envió, de 2 a
                           3 días hábiles (zona extendida no podrá ser enviada
                           de esta forma) a partir de la fecha de confirmación
                           del pago del producto o de 2 a 6 días hábiles a
                           partir de la fecha de confirmación del pago del
                           producto, todos los envíos se cotizan a través de la
                           tabla correspondiente a peso volumétrico y tiempo de
                           entrega en el cual el cliente lo especifique, de 81
                           kg en adelante se enviarán en base a la tabla que
                           maneje la paquetería para productos con peso
                           volumétrico fuera de lo ordinario.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           ENTREGA EN SUCURSAL.- (Valido únicamente para pagos
                           realizados con transferencia bancaria o Mercado Pago)
                           En el caso que el cliente opte por la recolección del
                           producto en alguna de nuestras sucursales, la cual no
                           tiene costo para el cliente, esta se realizara al
                           siguiente día hábil de haber realizado su compra
                           después de las 15:00 hrs. para recoger el paquete
                           solo deberá de llevar lleno el formato de producto
                           recibido (este se enviara al correo del comprador al
                           confirmar su pago del producto) junto con una
                           identificación oficial, esta opción de envió solo
                           aplica para las sucursales dentro de la
                           __________________________________.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Los tiempos de entrega son especificados en la orden
                           según el tiempo de entrega seleccionado por el
                           cliente al realizar la compra, recordando que los
                           días hábiles se manejan de lunes a viernes sin
                           incluir días feriados y partiendo del día posterior a
                           la compra del producto.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Todos los productos por la naturaleza de los mismos
                           cuentan con un periodo de 5 días naturales para poder
                           pedir un cambio por defecto de fábrica a partir de la
                           entrega marcada por la paquetería, nuestro compromiso
                           es garantizar la calidad de nuestros productos y
                           ayudar a nuestros clientes en el trámite si este se
                           presenta.
                        </p>
                        <div className="white-space-64"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default PoliticasCompra;



// WEBPACK FOOTER //
// ./src/pages/politicas-compra.js